import type { SVGProps } from 'react';

const SvgAnnotationText = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 5H6c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1s1-.45 1-1V7h4v10h-1c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1h-1V7h4v1c0 .55.45 1 1 1s1-.45 1-1V6c0-.55-.45-1-1-1"
    />
  </svg>
);
export default SvgAnnotationText;
